import { IconTab } from "@/src/components/iconTab";
import { Ventilation, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { CONFIG } from "@/src/data/globalVariables";
import { RiLungsLine } from "react-icons/ri";

function VentilationButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Ventilation) => void;
}) {
  return (
    <IconTab
      id={"ventilation"}
      activeTabId={null}
      isHorizontal={true}
      name={"Ventilation"}
      icon={<RiLungsLine size={22} />}
      onChange={async () => {
        let referenceId = jsonAbstract(
          getItemId(CONFIG.get()?.ventilationForm)
        ) as string;
        if (!referenceId)
          throw new Error(
            "Aucun formulaire de ventilation trouvé, veuillez contacter l'administrateur"
          );
        let reference = await apiFetch(
          "references",
          "loadOne",
          { referenceId },
          "Erreur lors du chargement de la référence"
        );
        let item: Ventilation = {
          type: "ventilation",
          patient,
          creator: getUserId(), 
          parent,
          reference,
          content: {
            patient,
            creator: getUserId(),
            fieldAnswers: [],
            reference,
          },
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };
        return await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("ventilations", "addOne", {
              ventilation: newItem,
            });
            onSave(newItem);
          },
        });
      }}
    />
  );
}

export default VentilationButton;
